export default {
  // Relationships
  activity: {
    jsonApi: 'hasOne',
    type: 'activities'
  },

  // Attributes
  author_description: null,
  identifier: null
}
